'use client'

import { useMemo } from 'react'
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from 'recharts'
import { TOOLTIP_STYLE, AXIS_STYLE, CHART_COLORS } from './chartConfig'

function histogram(arr: number[], bins = 8) {
  if (!arr.length) return []
  const mx = Math.max(...arr)
  const step = Math.max(Math.ceil(mx / bins), 1)
  return Array.from({ length: bins }, (_, i) => ({
    label: `${i * step}-${(i + 1) * step}d`,
    count: arr.filter(v => v >= i * step && v < (i + 1) * step).length,
  }))
}

export default function LeadCycleChart({ leads, cycles }: { leads: number[]; cycles: number[] }) {
  const data = useMemo(() => {
    const leadBins = histogram(leads)
    const cycleBins = histogram(cycles)
    return leadBins.map((lb, i) => ({
      label: lb.label,
      lead: lb.count,
      cycle: cycleBins[i]?.count || 0,
    }))
  }, [leads, cycles])

  return (
    <ResponsiveContainer width="100%" height={220}>
      <BarChart data={data}>
        <XAxis dataKey="label" {...AXIS_STYLE} />
        <YAxis {...AXIS_STYLE} width={25} />
        <Tooltip {...TOOLTIP_STYLE} />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        <Bar dataKey="lead" fill={CHART_COLORS.primary} name="Lead Time" radius={[2, 2, 0, 0]} />
        <Bar dataKey="cycle" fill={CHART_COLORS.primaryLight} name="Cycle Time" radius={[2, 2, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  )
}
